<template>
<div class="file-manage-view">
    <div class="file-manage-content">
      <div class="file-manage-center" ref="fileManageCenter">
        <div class="file-manage-worker-item" v-for="(item, index) in memberList">
          <div class="worker-avatar">
            <div v-if="
                (item.toType === 'PERSON' || item.toType === 'APP') &&
                  fileAvatar(item) === ''
              " class="user-avatar" :style="avatarColorStye(item.toName)">
              <div class="user-name">{{ userName(item.toName) }}</div>
            </div>
            <img v-else :src="fileAvatar(item)">
          </div>
          <div class="worker-info">
            <div class="worker-title">
              <div v-if="item.toName?.length < 5" class="worker-name" :style="userInfo.spaceId !== item.toSpace &&
item.toName !==
  $t(
    '知识库管理员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1'
  )
  ? ''
  : 'margin-right: 0px;'">
                {{ spliceMemberName(item) }}
              </div>
              <moo-tooltip v-else placement="top" popper-class="tooltip_css" :content="item.toName" :visible-arrow="false">
                <div class="worker-name" :style="(userInfo.spaceId !== item.toSpace &&
  item.toName !==
    $t(
      '知识库管理员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2'
    )) ||
item.toType === 'APP'
  ? ''
  : 'margin-right: 0px;'">
                  {{ spliceMemberName(item) }}
                </div>
              </moo-tooltip>
              <div v-if="userInfo.spaceId !== item.toSpace &&
  item.toName !==
    $t(
      '知识库管理员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_3'
    ) &&
  item.toType !== 'APP'" class="worker-space-name">
                @{{ item.toSpaceName }}
              </div>
              <div class="worker-tag" v-if="index === 0 && item.toType !== 'APP'">{{$t("所有者#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}              </div>
              <div class="worker-tag worker-tag-app" v-if="item.toType === 'APP'">{{$t("应用#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}              </div>
              <div v-if="!!item.inherit" class="worker-recover">{{$t("继承于父级文件#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}              </div>
            </div>
            <div class="worker-wiki-role" v-if="
                index !== 0 &&
                  (item.memberIdentity === 'ADMIN' ||
                    item.memberIdentity === 'MEMBER')
              ">
              {{ memberIdentity(item) }}
            </div>
          </div>
          <div class="worker-auth-diseditable" v-if="
              (myAuth !== 'ALL' && myAuth !== 'WRITE') ||
                (item.edit === false && index === 0) ||
                item.edit === false
            ">
            {{ authName(item.auth) }}
          </div>
          <moo-dropdown v-else ref="AuthDropDown" trigger="click" placement="bottom-end" @command="(cmd) => handlerChangeAuth(item,cmd, index)" @visible-change="(v) => dropdownMenuVisibleChange(v, index)">
            <div class="worker-auth-editable" @click="openAuthList(item, index)" @mouseover="mouseAction(index, true)" @mouseleave="mouseAction(index, false)">
              {{ authName(item.auth) }}
              <img :src="changeEditableIcon(index)">
            </div>
            <moo-dropdown-menu ref="AuthDropDownMenu" slot="dropdown">
              <div class="auth-list" v-for="(auth, i) in authList" :key="i">
                <moo-dropdown-item :command="i" :divided="
                    ['ALL', 'RECOVER', 'DELETE', 'NONE'].includes(auth.id)
                  " :disabled="item.edit === false || isDisabledAuth(auth)">
                  <div class="auth-name">
                    <img v-show="auth.id === item.auth && !isDisabledAuth(auth)" src="@/assets/h5/file/icon_file_selected.png">
                    <span :style="computedAuthStyle(auth, item)">{{
                      auth.name
                    }}</span>
                  </div>
                  <div class="auth-desc">{{ auth.desc }}</div>
                </moo-dropdown-item>
              </div>
              <div class="push-message">
                <span :style="
                    memberList[index].pushMessage
                      ? 'color: #222329;'
                      : 'color: #DDDFE6;'
                  ">{{$t("修改时发送通知#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}</span>
                <moo-switch class="auth-push-switch" v-model="memberList[index].pushMessage" active-color="#5C70FF" inactive-color="#DDDFE6"></moo-switch>
              </div>
            </moo-dropdown-menu>
          </moo-dropdown>
          <moo-dialog :top="isPcMode ? '35vh' : '35vh'" custom-class="cloud-common-dialog" :visible.sync="showPushMsgDialog" :modal-append-to-body="false" :width="isPcMode ? '448px' : '84%'" @closed="showPushMsgDialog = false">
            <div v-if="isPcMode">
              <div class="title">
                <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("提示#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}              </div>
              <div class="content">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}              </div>
              <div class="footer">
                <div class="custom-button link-button" @click.stop="
                    showPushMsgDialog = memberList[index].pushMessage = false
                  ">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}                </div>
                <div class="custom-button reconnect-button" @click.stop="modifyAuth(currentCmd, currentIndex)">{{$t("确认发送#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}                </div>
              </div>
            </div>
            <div class="mobile-content" v-else>
              <div class="title">{{$t("提示#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2")}}</div>
              <div class="content" :style="{ 'padding-left': '0px' }">{{$t("本次发送的通知范围较大，包括已选择的组织架构的所有成员。为避免打扰到同事，请谨慎发送。#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2")}}              </div>
              <div class="footer" :style="'justify-content: space-evenly;'">
                <div class="custom-button" @click.stop="
                    showPushMsgDialog = memberList[index].pushMessage = false
                  ">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2")}}                </div>
                <div class="custom-button reconnect-button" :style="'margin-left: 0px;'" @click.stop="modifyAuth(currentCmd, currentIndex)">{{$t("确认发送#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2")}}                </div>
              </div>
            </div>
          </moo-dialog>
        </div>
        <div class="file-manage-scrollbar" :class="{ hide: !showScrollbar }" ref="scrollbar"></div>
      </div>
    </div>
    <moo-dialog custom-class="common-dialog breakInhreitDialogClass" :append-to-body="true" :title="$t('权限变更#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1')" :visible.sync="breakInhreitDialogVisible" width="480px">
        <span>{{$t("当前页面将取消与父页面的权限关联，此后父页面的新增、删除、修改权限，均不会影响到本页面。是否继续？#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}</span>
        <span slot="footer" class="dialog-footer">
            <moo-button @click="breakInhreitDialogVisible = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_3")}}</moo-button>
            <moo-button type="primary" @click="changeAuth(currentCmd, currentIndex)">{{$t("确认#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")}}</moo-button>
        </span>
        </moo-dialog>
  </div>
</template>

<script>
import { intl } from 'tci18n-vue2'
import { deleteAuth, setFileAuth } from "@/api/h5/file";
import { AUTH_DETAIL_LIST } from "@/constants/file";
import { getNameColor, getLastName } from "@/utils/color";
import { getMemberAvatar } from "@/utils/avatar";
import { mapState } from "vuex";

export default {
  name: "FileShareManageView",
  props: {
    fileId: {
      type: String
    },
    myAuth: {
      type: String
    },
    shareAuthList: {
      type: Array
    },
    userInfo: {
      type: Object
    },
    isWiki: {
      type: Boolean,
      default: false
    },
    nonAdminMaxAuth: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      memberList: [],
      editableHover: [],
      editableFocus: [],
      authList: AUTH_DETAIL_LIST,
      showScrollbar: false,
      hideScrollbarTimer: null,
      showPushMsgDialog: false,
      currentCmd: null,
      currentIndex: null,
      breakInhreitDialogVisible: false
    };
  },
  watch: {
    shareAuthList: {
      handler(v) {
        if (v.length !== 0) {
          if (this.isWiki) {
            let owner = this.shareAuthList[0];
            let filterList = this.shareAuthList.filter((item, index) => {
              return (
                item.memberIdentity !== "ADMIN" ||
                index === this.shareAuthList.findIndex((x) => x === owner));

            });
            this.memberList = filterList.map((item) =>
            item.toType === "PERSON" ?
            { ...item, pushMessage: true } :
            { ...item, pushMessage: false }
            );
            // const adminItem = {
            //   toName: "知识库管理员",
            //   auth: "ALL",
            //   edit: false,
            // };
            // this.memberList.splice(1, 0, adminItem);
          } else {
            this.memberList = this.shareAuthList.map((item) =>
            item.toType === "PERSON" ?
            { ...item, pushMessage: true } :
            { ...item, pushMessage: false }
            );
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode
    })
  },
  created() {
    for (let i = 0; i < this.memberList.length; i++) {
      this.editableHover.push(false);
      this.editableFocus.push(false);
    }
  },
  mounted() {
    this.$refs.fileManageCenter.addEventListener("scroll", this.onListScroll);
  },
  beforeDestroy() {
    this.$refs.fileManageCenter.removeEventListener(
      "scroll",
      this.onListScroll
    );
    if (this.hideScrollbarTimer) {
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = null;
    }
  },
  methods: {
    isDisabledAuth(auth) {
      if (this.nonAdminMaxAuth) {
        const newAuthList = this.authList.filter(
          (i) => i.id !== "NONE" && i.id !== "DELETE" && i.id !== "RECOVER"
        );
        const maxAuthIndex = newAuthList.findIndex(
          (i) => i.id === this.nonAdminMaxAuth
        );
        const authIndex = newAuthList.findIndex((i) => i.id === auth.id);
        return maxAuthIndex < authIndex;
      } else {
        return false;
      }
    },
    computedAuthStyle(auth, item) {
      const disabledStyle = "color: #CCCED7 !important; margin-left: 36px";
      const activeStyle = "color: #5C70FF !important";
      const normalStyle = "color: #222329 !important; margin-left: 36px";
      const specailStyle = "color: #FF4747 !important; margin-left: 36px";
      const specailActiveStyle = "color: #FF4747 !important;";

      if (["DELETE", "NONE"].includes(auth.id)) {
        if (auth.id === item.auth) {
          return specailActiveStyle;
        } else {
          return specailStyle;
        }
      } else {
        const disabled = this.isDisabledAuth(auth);
        if (disabled) {
          return disabledStyle;
        }
        if (auth.id === item.auth) {
          return activeStyle;
        } else {
          return normalStyle;
        }
      }
    },
    spliceMemberName(item) {
      if (!item.toName) {
        return intl.$t("未知用户#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
      }
      if (!!item.inherit) {
        return item.toName.length > 10 ?
        item.toName.slice(0, 10) + "..." :
        item.toName;
      } else {
        return item.toName;
      }
    },
    onListScroll() {
      const listEl = this.$refs.fileManageCenter;
      const scrollbarEl = this.$refs.scrollbar;

      const scrollTop = listEl.scrollTop;
      const scrollHeight = listEl.scrollHeight;
      const clientHeight = listEl.clientHeight;
      const scrollbarHeight = clientHeight * clientHeight / scrollHeight;
      let extraTop = 0;
      if (this.myAuth === "ALL") {
        extraTop = 32 + 8;
      }
      const scrollbarTop =
      scrollTop * clientHeight / scrollHeight + 100 + extraTop;
      // 更新滚动条的高度和位置
      scrollbarEl.style.height = `${scrollbarHeight}px`;
      scrollbarEl.style.top = `${scrollbarTop}px`;

      this.showScrollbar = true;
      clearTimeout(this.hideScrollbarTimer);
      this.hideScrollbarTimer = setTimeout(() => {
        this.showScrollbar = false;
      }, 1000);
    },
    authName(auth) {
      switch (auth) {
        case "ALL":
          return intl.$t("所有权限#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
        case "READ":
          return intl.$t("仅查看#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
        case "READ_DOWNLOAD":
          return intl.$t("查看下载#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
        case "WRITE":
          return intl.$t("编辑#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
        case "NONE":
          return intl.$t("无权限#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
      }
    },
    memberIdentity(item) {
      switch (item.memberIdentity) {
        case "ADMIN":
          return intl.$t("知识库管理员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_4");
        case "MEMBER":
          return intl.$t("知识库成员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
      }
    },
    changeAuth(command, index) {
      this.breakInhreitDialogVisible = false;
      const fileId = this.fileId;
      if (
      this.authList[command].id === "DELETE" ||
      this.authList[command].id === "RECOVER")
      {
        /// 删除协作者 / 恢复于继承权限
        const to = this.memberList[index].to;
        const spaceId = this.memberList[index].toSpace;
        const type = this.memberList[index].toType;
        deleteAuth(to, true, fileId, spaceId, type).
        then((res) => {
          if (res.code === 200) {
            this.memberList = this.memberList.filter(
              (item, i) => i !== index
            );
            this.$emit("updateMemberAuthList");
            this.$message({
              message:
              this.authList[command].id === "DELETE" ? intl.$t("移除成功#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1") : intl.$t("恢复成功#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1"),


              type: "success"
            });
          } else {
            this.$message({
              message:
              this.authList[command].id === "DELETE" ? intl.$t(`移除失败，{slot0}#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1`, { slot0:
                res.message }) : intl.$t(`恢复失败，{slot0}#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1`, { slot0:
                res.message }),
              type: "error"
            });
          }
        }).
        catch((err) => {
          this.$message({
            message:
            this.authList[command].id === "DELETE" ? intl.$t("移除失败#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1") : intl.$t("恢复失败#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1"),


            type: "error"
          });
        });
      } else {
        if (this.memberList[index].toType !== "PERSON") {
          if (this.memberList[index].pushMessage) {
            this.showPushMsgDialog = true;
          } else {
            this.modifyAuth(command, index);
          }
        } else {
          this.modifyAuth(command, index);
        }
      }
    },
    handlerChangeAuth(item, command, index) {
      this.currentCmd = command;
      this.currentIndex = index;
      const selectAuth = this.authList[command].id;
      if (selectAuth === item.auth) return; // 无效操作，选择了相同的权限
      if (item.inheritAuth !== null) {
        const isDeleteAuth = selectAuth === 'DELETE';
        let isReduceAuth = false;
        const originalAuthIndex = this.authList.findIndex((i) => i.id === item.inheritAuth);
        isReduceAuth = command < originalAuthIndex && !isDeleteAuth;
        if (isDeleteAuth || isReduceAuth) {
          this.breakInhreitDialogVisible = true;
        } else {
          this.changeAuth(command, index);
        }
      } else {
        this.changeAuth(command, index);
      }
    },
    modifyAuth(command, index) {
      this.showPushMsgDialog = false;
      const fileId = this.fileId;
      /// 修改权限
      const list = [
      {
        auth: this.authList[command].id,
        to: this.memberList[index].to,
        toSpace: this.memberList[index].toSpace,
        toType: this.memberList[index].toType
      }];

      const pushMessage = this.memberList[index].pushMessage;
      const data = { fileId: fileId, list: list, pushMessage: pushMessage };
      setFileAuth(data).
      then((res) => {
        if (res.code === 200) {
          this.memberList[index].auth = this.authList[command].id;
          this.$emit("updateMemberAuthList");
          this.$message({
            message: intl.$t("修改用户权限成功#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1"),
            type: "success"
          });
        } else {
          this.$message({
            message: intl.$t("修改用户权限失败#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1"),
            type: "error"
          });
        }
      }).
      catch((err) => {
        this.$message({
          message: intl.$t("修改用户权限失败#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_2"),
          type: "error"
        });
      });
    },
    openAuthList(item, index) {
      this.$set(this.editableFocus, index, !this.editableFocus[index]);

      if (!this.editableFocus[index]) {
        return;
      }
      if (item.memberIdentity === "COLLABORATOR" || item.memberIdentity === "MEMBER") {
        if (this.authList.some((item) => item.id === "NONE")) {
          this.authList = this.authList.filter((i) => i.id !== "NONE");
        }
        if (!this.authList.some((item) => item.id === "DELETE")) {
          this.$set(this.authList, this.authList.length, {
            id: "DELETE",
            name: intl.$t("删除协作者#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1")
          });
        }
        // }
      }
      //默认都不发送通知
      this.memberList[index].pushMessage = false;
      //   if (item.toType === "PERSON") {
      //     this.memberList[index].pushMessage = false;
      //   } else {
      //     this.memberList[index].pushMessage = false;
      //   }
    },
    dropdownMenuVisibleChange(visible, index) {
      if (!visible) {
        this.$set(this.editableFocus, index, visible);
        this.$set(this.editableHover, index, visible);
      }
    },
    mouseAction(index, isHover) {
      if (this.editableFocus[index] === true && !isHover) {
        this.$set(this.editableHover, index, true);
        return;
      }
      this.$set(this.editableHover, index, isHover);
    },
    changeEditableIcon(index) {
      return this.editableFocus[index] ?
      require("@/assets/h5/file/icon_file_auth_editable_selected.png") :
      this.editableHover[index] ?
      require("@/assets/h5/file/icon_file_auth_editable_hover.png") :
      require("@/assets/h5/file/icon_file_auth_editable.png");
    },
    fileAvatar(item) {
      if (item.toType === "PERSON" || item.toType === "APP") {
        const userAvatar = getMemberAvatar(item.toAvatar, "");
        return userAvatar["100"] ?? userAvatar["300"] ?? userAvatar["original"];
      } else if (item.toName === intl.$t("知识库管理员#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_5")) {
        return require("@/assets/h5/file/icon_file_manager.png");
      } else if (item.toType === "GROUP") {
        if (item.toAvatar && item.toAvatar.length > 0) {
          return item.toAvatar;
        }
        return require("@/assets/h5/file/fp_user_group.png");
      } else if (item.toType === "USER_GROUP") {
        return require("@/assets/h5/file/fp_user_group.png");
      } else if (
      item.toType === "DEPARTMENT" &&
      item.toSpace !== this.userInfo.spaceId)
      {
        return require("@/assets/h5/file/finder_dept_sub_united.png");
      } else {
        return require("@/assets/h5/file/icon_file_file.png");
      }
    },
    avatarColorStye(name) {
      if (!name) {
        return "background-color: #5C70FF";
      }
      let avatarColor = getNameColor(name);
      return `background-color: ${avatarColor}`;
    },
    userName(name) {
      if (!name) {
        return intl.$t("未知#!!!#src/pages/H5/Cloud/components/share/FileShareManageView.vue_1");
      }
      return getLastName(name);
    }
  }
};
</script>

<style lang="scss" scoped>
.file-manage-view {
  display: flex;
  flex-direction: column;
  flex: 1;

  .file-manage-content {
    display: flex;
    flex-direction: column;
    flex: 1;

    .file-manage-center {
      display: flex;
      flex-direction: column;
      min-height: 40px;
      max-height: 200px;
      overflow-x: hidden;
      overflow-y: auto;

      &::-webkit-scrollbar {
        display: none;
      }

      .file-manage-worker-item {
        width: 100%;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        margin-bottom: 4px;
        cursor: pointer;

        &:hover {
          background-color: #f4f6f9;
          border-radius: 8px;
        }

        .worker-avatar {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          margin-right: 12px;
          margin-left: 4px;

          img {
            width: 32px;
            height: 32px;
            border-radius: 8px;
          }

          .user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;

            .user-name {
              font-family: "PingFang SC", sans-serif;
              font-weight: 600;
              font-size: 12px;
              color: #ffffff;
              letter-spacing: 0;
              line-height: 17px;
            }
          }
        }

        .worker-info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: space-between;
          flex: 1;
          height: 40px;
          margin-right: 4px;

          .worker-title {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            height: 100%;

            .worker-name {
              font-family: PingFangSC-Regular;
              font-weight: 300;
              font-size: 14px;
              color: #323233;
              letter-spacing: 0;
              line-height: 20px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
            }

            .worker-space-name {
              margin-left: 4px;
              color: #fc7d29;
              font-family: PingFangSC-Regular;
              font-weight: 300;
              font-size: 14px;
              letter-spacing: 0;
              line-height: 20px;
              display: flex;
              flex-shrink: 0;
            }

            .worker-tag-app {
              background-color: #fff1ee !important;
              color: #f05f11 !important;
            }

            .worker-tag {
              height: 18px;
              padding: 0 4px;
              margin-left: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 4px;
              background-color: #eef0ff;
              font-family: PingFangSC-Medium;
              font-weight: 500;
              font-size: 10px;
              color: #5c70ff;
              letter-spacing: 0;
              line-height: 14px;
            }

            .worker-recover {
              font-size: 12px;
              font-family: "PingFang SC", sans-serif;
              color: #fba724;
              margin-left: 8px;
              display: flex;
              flex-shrink: 0;
            }
          }

          .worker-wiki-role {
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #a2a4b0;
            letter-spacing: 0;
            line-height: 20px;
          }
        }

        .worker-auth-diseditable {
          font-family: PingFangSC-Regular;
          font-weight: 300;
          font-size: 14px;
          color: #222329;
          letter-spacing: 0;
          line-height: 20px;
          margin-right: 8px;
        }

        .worker-auth-editable {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          height: 32px;
          margin-right: 8px;
          font-family: PingFangSC-Regular;
          font-weight: 300;
          font-size: 14px;
          color: #222329;
          letter-spacing: 0;
          text-align: center;
          line-height: 20px;
          border: none;
          background-color: transparent;
          cursor: pointer;

          &:hover {
            color: #5c70ff;
          }

          img {
            margin-left: 4px;
            width: 10px;
            height: 10px;
            object-fit: contain;
          }

          .editable-icon {
            margin-left: 4px;
            width: 10px;
            height: 10px;
          }
        }
      }

      .file-manage-scrollbar {
        position: absolute;
        right: 4px;
        top: 0;
        width: 4px;
        background-color: #dcddde;
        border-radius: 3px;
        transition: opacity 0.2s ease-in-out;

        &.hide {
          opacity: 0;
        }
      }
    }
  }
}

.moo-popper {
  margin-top: 8px !important;
  margin-right: 8px !important;
  padding: 4px 0px 0px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 258px !important;

  .push-message {
    height: 28px;
    padding: 4px 16px 0 36px;
    margin: 4px;
    border-top: 1px solid #f1f4f5;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    span {
      flex: 1;
      font-size: 14px;
      font-weight: 300;
      font-family: PingFangSC-Regular;
      line-height: 20px;
      transition: color 0.2s ease-in-out;
    }
  }
}

.moo-dropdown-menu__item {
  min-height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px 4px 4px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  justify-content: center !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .auth-name {
    padding: 4px 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      width: 15px;
      height: 11px;
      margin: 0 11px;
    }

    span {
      font-size: 14px !important;
      font-weight: 300 !important;
      font-family: PingFangSC-Regular !important;
      color: #222329 !important;
      line-height: 20px;
      flex: 1;
    }

    .auth-push-switch {
      margin-right: 16px;
    }
  }

  .auth-desc {
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #a5a7b3;
    letter-spacing: 0;
    line-height: 17px;
    margin: 0 16px 4px 36px;
    white-space: pre-wrap !important;
    word-break: break-word;
  }
}

.moo-dropdown-menu__item--divided {
  border-top: 1px solid #f1f4f5;
}
</style>

<style lang="scss">
@import "~@/styles/cloudCommonDialog.scss";

.cloud-common-dialog {
  box-shadow: none !important;
}

.tooltip_css {
  border-radius: 8px !important;
  color: #767c85 !important;
  font-size: 14px !important;
  font-weight: 400 !important;
  padding: 8px !important;
  background-color: #ffffff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  max-width: 400px !important;
}
</style>

<style lang="scss">
.moo-dialog__header {
    display: block !important;
    padding: 24px 24px 10px 24px;
}
.breakInhreitDialogClass {
  width: 529px;
  height: 172px;

  .moo-dialog__header {
    display: block !important;
    padding: 24px 24px 10px 24px;

    .moo-dialog__title {
      font-weight: 600;
      font-size: 16px;
      color: #000000d9;
      line-height: 24px;
    }

    .moo-dialog__headerbtn {
      display: none;
    }
  }

  .moo-dialog__body {
    padding: 6px 24px 12px 24px;

    font-weight: 400;
    font-size: 14px;
    color: #121317;
    line-height: 20px;
  }

  .moo-dialog__footer {
    .dialog-footer {
      .moo-button {
        line-height: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 76px;
        height: 32px;
      }

      .moo-button--default {
        background-color: #ffffff;
        color: #222329;
        &:hover {
          color: #222329;
          background-color: #e8e9ee;
        }
      }

      .moo-button--primary {
        background-color: #5c70ff;
        &:hover {
          background-color: #6d7dff;
        }
      }
    }
  }
}

.v-modal {
  opacity: 0.4 !important;
}
</style>
